
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";

interface LeaksSearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  leaksCount: number;
  filteredCount: number;
}

export function LeaksSearchBar({
  searchQuery,
  setSearchQuery,
  leaksCount,
  filteredCount
}: LeaksSearchBarProps) {
  const { t } = useLanguage();

  return (
    <div className="max-w-md mx-auto mb-8">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder={t('leaks.searchPlaceholder')}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 shadow-sm"
        />
        {searchQuery && (
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 h-6 w-6"
            onClick={() => setSearchQuery('')}
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
      {filteredCount < leaksCount && (
        <p className="text-sm text-muted-foreground mt-2">
          {t('leaks.searchResults', { count: filteredCount })}
        </p>
      )}
    </div>
  );
}
